<template>
  <div class="app-container">
    <div class="app-header">
      <div class="app-header__title">
        <slot name="head">
          <div class="app-header__group">
            <div class="app-header__column">
              <h2 v-if="title">{{ title }}</h2>
              <ButtonCreate
                :show="buttonCreateShow"
                :name="buttonCreateName"
                :link="link"
              />
            </div>
            <div class="app-header__controls">
              <slot name="controls" />
            </div>
          </div>
        </slot>
      </div>
    </div>
    <slot name="body" />
  </div>
</template>

<script>
import ButtonCreate from "./ButtonCreate";

export default {
  components: {
    ButtonCreate,
  },
  props: {
    buttonCreateShow: {
      type: Boolean,
      default: false,
    },
    buttonCreateName: {
      type: String,
      default: "Создать",
    },
    scheme: {
      type: Object,
      default: null,
    },
    methods: {
      type: Object,
      default() {
        return {};
      },
    },
    link: {
      type: String,
      default: "create",
    },
  },
  computed: {
    title() {
      const {
        meta: { title },
      } = this.$route;
      return title;
    },
    meta() {
      return this.$route.meta;
    },
  },
};
</script>
